import {  FC,useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import {  useLocation, useHistory } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";
import { Link } from 'react-router-dom';
import { Breadcrumb } from "react-bootstrap";

const ViewJobApplication: FC = ({ hrefIn }:any) => {
      const intl = useIntl();
      let history = useHistory();
      const [categories, setCategory] = useState([]);
      const [locationCounty, setLocationCounty] = useState([]);
      //const [applicationinfo, setApplicationInfo] = useState([]);
      const [applicationinfo, setApplicationInfo] =  useState<any>([]);
      const [jobTypes, setJobType] = useState([]);
        const red="red";
        var companytitle_name;
        const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const jobapplicationId = queryParams.get('jobapplicationId');
      const [pdfDownload, setPdfDownload] = useState([]);
      const [displayTitle, setDisplayTitle] = useState([]);

      var tabId = queryParams.get('tab');
      var companyId = queryParams.get('companyIdget');

      const items = [
         { href: "/companyDetails?companyId="+companyId+"&tab=1", name: "Company Details" },
        { href: "/companyDetails?companyId="+companyId+"&tab="+tabId, name: "Job Applications" },
        {  name: "view Application" },
      ];

      const {
         register,
         formState: { errors },
         handleSubmit
       } = useForm({
         criteriaMode: "all",mode: "onBlur" 
       }); 

      function validateCheck() {
        //alert("test");
      } 

      function getApplicationInfo(jobapplicationId){
        const siteId = "2";
     const requestObject=
          {
            "applicationJobId" : jobapplicationId,

          }
          console.log(requestObject); 
          var accessTokenIn=sessionStorage.getItem("adminAccToken");
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
                      //'Authorization': "Bearer "+accessTokenIn 
                      //'Authorization': accessTokenIn 
                    },
            body: JSON.stringify(requestObject)
          };

           services.admincallViewJobapplication(requestOptions).then((res) => 
          {
            setApplicationInfo(res);
            setPdfDownload(res.resumePath);
            setDisplayTitle(res.jobTitle);
          });
      };

      const submitValue=()=>
      {

      
      
      }
      
      useEffect(() => {

        validateCheck();
        getApplicationInfo(jobapplicationId);
        $("#companyProfileValidMsg").hide(); 
        services.getIndustryData().then((res) => 
         {
               //console.log("count"+res);
               setCategory(res.data.content);
         }) 
         services.getLocationCounty().then((res) => {
            //console.log("getLocationCounty data=" + JSON.stringify(res.data));
            setLocationCounty(res.data.content);
          });
          services.getJobType().then((res) => {
            console.log("setJobType data=" + JSON.stringify(res.data));
            setJobType(res.data.content);
          });
        
      }, []);
      
      return (
        <>
        {tabId == null ? '' : <Breadcrumb style={{opacity:"0.8", paddingBottom:"15px", marginTop:"-15px", borderBottom:"1px solid #999 "}}>
      {items.map((item) =>
        item.href === hrefIn ? (
          <Breadcrumb.Item active>{item.name}</Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item linkProps={{ to: item.href }} linkAs={Link}>
            {item.name}
          </Breadcrumb.Item>
        )
      )}
    </Breadcrumb>
    }
          <PageTitle breadcrumbs={[]}>{displayTitle}</PageTitle>
          <form onSubmit={handleSubmit(submitValue)}>
          <div className="container">
               <div className="row">
               <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                <img src={applicationinfo.profilePicS3URL ? applicationinfo.profilePicS3URL : "images/user-default.jpg"} style={{maxWidth:"150px",maxHeight:"150px"}} alt=""/>
                 </div>                
              </div>
                 </div>
                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Applicant Name : </b>{applicationinfo.firstName} {applicationinfo.lastName}</label>
               
                 </div>             
              </div>
                 </div>
                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Applied On : </b>{moment(applicationinfo.createdDate).format("MM/DD/YYYY")}</label>
               
                 </div>            
              </div>
                 </div>
               <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Job Title : </b>{applicationinfo.jobTitle} </label>
               
                 </div>                
              </div>
                 </div> 
                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Company Name :  </b>{applicationinfo.companyName}</label>
               
                 </div>                
              </div>
                 </div>

                
                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Applicant Email : </b>{applicationinfo.email}</label>
               
                 </div>            
              </div>
                 </div>
                 <div className="col-lg-6">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Applicant Phone Number : </b>{applicationinfo.phone}</label>
               
                 </div>          
              </div>
                 </div>
                 
                 
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Seeking : </b>{applicationinfo.jobTypeName}</label>
               
                 </div>               
              </div>
                 </div>
                 
                 {/*
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label">Status : {applicationinfo.status}</label>
               
                 </div>          
              </div>
                 </div> */}
{/*
<div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Personal Profile : </b></label>
                 </div>    
                 <p dangerouslySetInnerHTML={{ __html: applicationinfo.personalProfile  }} />
                   
              </div>
                 </div>*/}
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="form-label"><b>Profile Summary : </b></label>
                 </div>   
                 <p dangerouslySetInnerHTML={{ __html: applicationinfo.profileSummary  }} />      
              </div>
                 </div>
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className=" form-label"><b>Education/Experience : </b></label>
                 </div>  
                 <p dangerouslySetInnerHTML={{ __html: applicationinfo.educationExperiance  }} /> 
                      
              </div>
                 </div>
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className=" form-label"><b>Position Looking For : </b></label>
                 </div>   
                 <p dangerouslySetInnerHTML={{ __html: applicationinfo.lookingFor  }} />
              </div>
                 </div>
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className=" form-label"><b>Certification/Training : </b></label>
                 </div>   
                 <p dangerouslySetInnerHTML={{ __html: applicationinfo.certificationsTrainingInfo  }} />
              </div>
                 </div>
                 <div className="col-lg-12">
                 <div className="mb-10">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className=" form-label"><b>Resume : </b></label>
                 </div>   
                 <a href={applicationinfo.resumePath} download="resume" target="_blank"><button type="button" className="btn btn-primary mt-10" style={{maxWidth: "200px"}}>Download</button></a>
              </div>
                 </div>
               
               </div>
             </div>
</form>
        </>
      )
    }
export {ViewJobApplication}